import { STEPS } from "./constants";

export const StepIndicator = ({ step }) => (
  <div className="flex items-center justify-between mb-10">
    {STEPS.map((s, i) => (
      <div key={s} className="flex-1 flex items-center">
        <div
          data-testid={`quote-step-indicator-${i}`}
          className={`h-1.5 w-full mx-1 rounded-full transition-colors ${i <= step ? "bg-twp-gold" : "bg-white/10"}`}
        />
      </div>
    ))}
  </div>
);
